import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { format, parseISO } from 'date-fns';

export function fmtDate(d) {
  try { return format(parseISO(d), 'dd/MM/yyyy'); } catch { return d || '-'; }
}

export function fmtDateShort(d) {
  try { return format(parseISO(d), 'dd/MM'); } catch { return d || '-'; }
}

export function pct(v) {
  return v === null || v === undefined ? '—' : `${v}%`;
}

const KPI_COLORS = {
  indigo: { bg: 'bg-indigo-100', text: 'text-indigo-600' },
  emerald: { bg: 'bg-emerald-100', text: 'text-emerald-600' },
  sky: { bg: 'bg-sky-100', text: 'text-sky-600' },
  violet: { bg: 'bg-violet-100', text: 'text-violet-600' },
  amber: { bg: 'bg-amber-100', text: 'text-amber-600' },
  red: { bg: 'bg-red-100', text: 'text-red-600' },
};

export function KpiCard({ icon: Icon, label, value, sub, color = 'indigo', testId }) {
  const c = KPI_COLORS[color] || KPI_COLORS.indigo;
  return (
    <Card className="border-0 shadow-sm" data-testid={testId}>
      <CardContent className="p-4">
        <div className="flex items-center gap-3">
          <div className={`w-10 h-10 rounded-xl ${c.bg} flex items-center justify-center flex-shrink-0`}>
            <Icon className={`w-5 h-5 ${c.text}`} />
          </div>
          <div className="min-w-0">
            <p className="text-2xl font-bold text-slate-900">{value}</p>
            <p className="text-[11px] text-slate-500 truncate">{label}</p>
            {sub && <p className="text-[10px] text-slate-400">{sub}</p>}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

const PRESENCE_STYLES = {
  present: { cls: 'bg-emerald-100 text-emerald-700', label: 'Présent' },
  retard: { cls: 'bg-amber-100 text-amber-700', label: 'Retard' },
  absent: { cls: 'bg-red-100 text-red-700', label: 'Absent' },
};

export function PresenceBadge({ statut }) {
  const cfg = PRESENCE_STYLES[statut] || { cls: 'bg-slate-100 text-slate-500', label: statut };
  return <Badge className={`${cfg.cls} border-0 font-medium`}>{cfg.label}</Badge>;
}

export function LoadingCard() {
  return (
    <Card>
      <CardContent className="p-6 space-y-3">
        {[1, 2, 3].map(i => <div key={i} className="h-10 bg-slate-100 rounded animate-pulse" />)}
      </CardContent>
    </Card>
  );
}

export function EmptyCard({ message }) {
  return (
    <Card className="border-dashed">
      <CardContent className="py-12 text-center text-slate-400">{message}</CardContent>
    </Card>
  );
}
